// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

// Telefon giris bileseni icin ulke listesi — tek kaynak (tum projede ayni).
// flag = ISO iki harf (bayrak SVG'si icin), dial = ulke kodu, groups = yerel numara gruplama deseni.
export interface PhoneCountry {
  readonly code: string;   // ISO 3166-1 alpha-2
  readonly name: string;   // Turkce ad
  readonly dial: string;   // + olmadan ( or. "90")
  readonly groups: readonly number[]; // yerel numara gruplama (TR: 3-3-2-2)
}

// TR en ustte (varsayilan). Sonrasi: komsular + AB + baslica dunya. Genisletilebilir.
export const PHONE_COUNTRIES: readonly PhoneCountry[] = [
  { code: 'TR', name: 'Türkiye', dial: '90', groups: [3, 3, 2, 2] },
  { code: 'DE', name: 'Almanya', dial: '49', groups: [3, 4, 4] },
  { code: 'US', name: 'ABD', dial: '1', groups: [3, 3, 4] },
  { code: 'GB', name: 'Birleşik Krallık', dial: '44', groups: [4, 3, 3] },
  { code: 'NL', name: 'Hollanda', dial: '31', groups: [1, 4, 4] },
  { code: 'FR', name: 'Fransa', dial: '33', groups: [1, 2, 2, 2, 2] },
  { code: 'AZ', name: 'Azerbaycan', dial: '994', groups: [2, 3, 2, 2] },
  { code: 'RU', name: 'Rusya', dial: '7', groups: [3, 3, 2, 2] },
  { code: 'AT', name: 'Avusturya', dial: '43', groups: [3, 4, 4] },
  { code: 'BE', name: 'Belçika', dial: '32', groups: [3, 2, 2, 2] },
  { code: 'BG', name: 'Bulgaristan', dial: '359', groups: [2, 3, 4] },
  { code: 'CH', name: 'İsviçre', dial: '41', groups: [2, 3, 2, 2] },
  { code: 'CN', name: 'Çin', dial: '86', groups: [3, 4, 4] },
  { code: 'CZ', name: 'Çekya', dial: '420', groups: [3, 3, 3] },
  { code: 'DK', name: 'Danimarka', dial: '45', groups: [2, 2, 2, 2] },
  { code: 'EG', name: 'Mısır', dial: '20', groups: [2, 4, 4] },
  { code: 'ES', name: 'İspanya', dial: '34', groups: [3, 3, 3] },
  { code: 'FI', name: 'Finlandiya', dial: '358', groups: [2, 3, 4] },
  { code: 'GE', name: 'Gürcistan', dial: '995', groups: [3, 3, 3] },
  { code: 'GR', name: 'Yunanistan', dial: '30', groups: [3, 3, 4] },
  { code: 'HU', name: 'Macaristan', dial: '36', groups: [2, 3, 4] },
  { code: 'IL', name: 'İsrail', dial: '972', groups: [2, 3, 4] },
  { code: 'IN', name: 'Hindistan', dial: '91', groups: [5, 5] },
  { code: 'IQ', name: 'Irak', dial: '964', groups: [3, 3, 4] },
  { code: 'IR', name: 'İran', dial: '98', groups: [3, 3, 4] },
  { code: 'IT', name: 'İtalya', dial: '39', groups: [3, 3, 4] },
  { code: 'JP', name: 'Japonya', dial: '81', groups: [2, 4, 4] },
  { code: 'KW', name: 'Kuveyt', dial: '965', groups: [4, 4] },
  { code: 'KZ', name: 'Kazakistan', dial: '7', groups: [3, 3, 2, 2] },
  { code: 'LB', name: 'Lübnan', dial: '961', groups: [1, 3, 3] },
  { code: 'LY', name: 'Libya', dial: '218', groups: [2, 3, 4] },
  { code: 'MA', name: 'Fas', dial: '212', groups: [3, 3, 3] },
  { code: 'NO', name: 'Norveç', dial: '47', groups: [3, 2, 3] },
  { code: 'PL', name: 'Polonya', dial: '48', groups: [3, 3, 3] },
  { code: 'PT', name: 'Portekiz', dial: '351', groups: [3, 3, 3] },
  { code: 'QA', name: 'Katar', dial: '974', groups: [4, 4] },
  { code: 'RO', name: 'Romanya', dial: '40', groups: [3, 3, 3] },
  { code: 'SA', name: 'Suudi Arabistan', dial: '966', groups: [2, 3, 4] },
  { code: 'SE', name: 'İsveç', dial: '46', groups: [2, 3, 2, 2] },
  { code: 'SY', name: 'Suriye', dial: '963', groups: [3, 3, 3] },
  { code: 'TM', name: 'Türkmenistan', dial: '993', groups: [2, 2, 2, 2] },
  { code: 'UA', name: 'Ukrayna', dial: '380', groups: [2, 3, 2, 2] },
  { code: 'AE', name: 'BAE', dial: '971', groups: [2, 3, 4] },
  { code: 'UZ', name: 'Özbekistan', dial: '998', groups: [2, 3, 2, 2] },
];

export const DEFAULT_PHONE_COUNTRY: PhoneCountry =
  PHONE_COUNTRIES.find((c) => c.code === 'TR') ?? PHONE_COUNTRIES[0]!;

// ISO koddan bayrak emoji (regional indicator). Windows'ta harf gorunur — bilesende SVG bayrak kullanilir.
export function isoToFlagEmoji(iso: string): string {
  return iso
    .toUpperCase()
    .replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));
}

// Dial koduna gore ulke bul (en uzun eslesme). Bulamazsa varsayilan (TR).
export function findCountryByDial(digitsWithoutPlus: string): PhoneCountry {
  let best: PhoneCountry | null = null;
  for (const c of PHONE_COUNTRIES) {
    if (digitsWithoutPlus.startsWith(c.dial)) {
      if (!best || c.dial.length > best.dial.length) best = c;
    }
  }
  return best ?? DEFAULT_PHONE_COUNTRY;
}

// Yerel rakamlari ulke desenine gore gruplayarak formatla (or. TR "555 111 22 33").
export function groupLocalDigits(localDigits: string, country: PhoneCountry): string {
  const digits = localDigits.replace(/\D/g, '');
  if (!digits) return '';
  const out: string[] = [];
  let i = 0;
  for (const g of country.groups) {
    if (i >= digits.length) break;
    out.push(digits.slice(i, i + g));
    i += g;
  }
  if (i < digits.length) out.push(digits.slice(i)); // desenin otesindeki fazla haneler
  return out.join(' ');
}
